import ErrorMessage from '../ErrorMessage';

export default class NoAudioError extends Error {
  name = ErrorMessage.NO_AUDIO;
}
